import { APIData, appFetch } from ".";

export interface Country {
  id: number;
  name: string;
  created_at: string;
}

export const countriesAPI = {
  fetch() {
    return appFetch<APIData<Country[]>>("/countries");
  },
};
